module.exports = __webpack_public_path__ + "img/anquan.71078821.png";